const translations = {
  en: {
    nav: {
      home: "Home",
      scan: "Scan Crop",
      doctor: "Crop Doctor",
      weather: "Weather",
      tagline: "AI-powered crop health"
    },
    home: {
      hero_title: "Protect Your Crops",
      hero_subtitle: "with AI",
      hero_desc: "Upload a photo of your crop and get instant disease detection, treatment advice, and expert farming guidance — completely free.",
      cta_scan: "Scan Your Crop Now",
      cta_doctor: "Ask Crop Doctor",
      how_title: "How FarmScan Works",
      step1_title: "Upload Photo",
      step1_desc: "Take a clear photo of your affected crop leaf or stem",
      step2_title: "AI Analyzes",
      step2_desc: "Our AI model scans for 38 known crop diseases instantly",
      step3_title: "Get Results",
      step3_desc: "Receive disease name, severity and treatment in your language",
      features_title: "Everything a Farmer Needs",
      feat1_title: "Disease Detection",
      feat1_desc: "Instant AI-powered detection from a simple photo",
      feat2_title: "Crop Doctor",
      feat2_desc: "Ask any farming question, get expert AI answers",
      feat3_title: "Weather Alerts",
      feat3_desc: "Farming tips based on your local weather forecast",
      feat4_title: "38 Crop Diseases",
      feat4_desc: "Trained on 54,000+ real crop disease images",
      stats_scans: "Scans Done",
      stats_diseases: "Diseases Detected",
      stats_farmers: "Farmers Helped",
      stats_accuracy: "Accuracy"
    },
    scan: {
      title: "Scan Your Crop",
      subtitle: "Upload a photo to detect disease instantly",
      upload_title: "Drop your crop photo here",
      upload_sub: "Take a close-up of the affected leaf or stem",
      upload_btn: "Choose Photo",
      crop_label: "Select crop type",
      scan_btn: "Scan for Disease",
      scanning: "Analyzing...",
      result_title: "Scan Result",
      confidence: "Confidence",
      severity: "Severity",
      affected: "Affected Area",
      treatment: "Recommended Treatment",
      scan_again: "Scan Another",
      healthy: "Your crop looks healthy!",
      no_disease: "No disease detected"
    },
    doctor: {
      title: "Crop Doctor",
      subtitle: "Ask any farming question, get expert advice",
      placeholder: "e.g. My tomato leaves are turning yellow...",
      send: "Ask Doctor",
      thinking: "Thinking...",
      welcome: "Hello! I am your AI Crop Doctor. Ask me anything about farming, crop diseases, fertilizers, or soil health."
    },
    weather: {
      title: "Weather & Farming Alerts",
      subtitle: "Local forecast with farming tips",
      detecting: "Detecting your location...",
      humidity: "Humidity",
      wind: "Wind",
      visibility: "Visibility",
      forecast: "5-Day Forecast",
      tip_title: "Today's Farming Tip",
      feel: "Feels like"
    }
  },
  hi: {
    nav: {
      home: "होम",
      scan: "फसल स्कैन",
      doctor: "फसल डॉक्टर",
      weather: "मौसम",
      tagline: "AI फसल स्वास्थ्य"
    },
    home: {
      hero_title: "अपनी फसल बचाएं",
      hero_subtitle: "AI के साथ",
      hero_desc: "अपनी फसल की फोटो अपलोड करें और तुरंत बीमारी की पहचान, उपचार की सलाह पाएं — बिल्कुल मुफ्त।",
      cta_scan: "अभी फसल स्कैन करें",
      cta_doctor: "फसल डॉक्टर से पूछें",
      how_title: "FarmScan कैसे काम करता है",
      step1_title: "फोटो अपलोड करें",
      step1_desc: "प्रभावित पत्ती या तने की स्पष्ट फोटो लें",
      step2_title: "AI विश्लेषण करता है",
      step2_desc: "हमारा AI मॉडल तुरंत 38 बीमारियों की जांच करता है",
      step3_title: "परिणाम पाएं",
      step3_desc: "अपनी भाषा में बीमारी का नाम और उपचार जानें",
      features_title: "किसान की हर जरूरत",
      feat1_title: "बीमारी पहचान",
      feat1_desc: "फोटो से तुरंत AI द्वारा पहचान",
      feat2_title: "फसल डॉक्टर",
      feat2_desc: "कोई भी सवाल पूछें, विशेषज्ञ जवाब पाएं",
      feat3_title: "मौसम अलर्ट",
      feat3_desc: "स्थानीय मौसम पर आधारित खेती सुझाव",
      feat4_title: "38 फसल रोग",
      feat4_desc: "54,000+ वास्तविक छवियों पर प्रशिक्षित",
      stats_scans: "स्कैन हुए",
      stats_diseases: "बीमारियां मिलीं",
      stats_farmers: "किसान लाभान्वित",
      stats_accuracy: "सटीकता"
    },
    scan: {
      title: "फसल स्कैन करें",
      subtitle: "बीमारी तुरंत पहचानने के लिए फोटो अपलोड करें",
      upload_title: "यहाँ फोटो डालें",
      upload_sub: "प्रभावित पत्ती या तने की नजदीकी फोटो लें",
      upload_btn: "फोटो चुनें",
      crop_label: "फसल का प्रकार चुनें",
      scan_btn: "बीमारी स्कैन करें",
      scanning: "विश्लेषण हो रहा है...",
      result_title: "स्कैन परिणाम",
      confidence: "विश्वास",
      severity: "गंभीरता",
      affected: "प्रभावित क्षेत्र",
      treatment: "अनुशंसित उपचार",
      scan_again: "दूसरा स्कैन करें",
      healthy: "आपकी फसल स्वस्थ दिखती है!",
      no_disease: "कोई बीमारी नहीं मिली"
    },
    doctor: {
      title: "फसल डॉक्टर",
      subtitle: "कोई भी खेती का सवाल पूछें",
      placeholder: "जैसे: मेरे टमाटर के पत्ते पीले हो रहे हैं...",
      send: "डॉक्टर से पूछें",
      thinking: "सोच रहा है...",
      welcome: "नमस्ते! मैं आपका AI फसल डॉक्टर हूं। खेती, बीमारी, खाद या मिट्टी के बारे में कुछ भी पूछें।"
    },
    weather: {
      title: "मौसम और खेती अलर्ट",
      subtitle: "खेती सुझावों के साथ स्थानीय पूर्वानुमान",
      detecting: "आपका स्थान पता कर रहे हैं...",
      humidity: "नमी",
      wind: "हवा",
      visibility: "दृश्यता",
      forecast: "5 दिन का पूर्वानुमान",
      tip_title: "आज का खेती सुझाव",
      feel: "महसूस होता है"
    }
  },
  kn: {
    nav: {
      home: "ಮನೆ",
      scan: "ಬೆಳೆ ಸ್ಕ್ಯಾನ್",
      doctor: "ಬೆಳೆ ವೈದ್ಯ",
      weather: "ಹವಾಮಾನ",
      tagline: "AI ಬೆಳೆ ಆರೋಗ್ಯ"
    },
    home: {
      hero_title: "ನಿಮ್ಮ ಬೆಳೆ ರಕ್ಷಿಸಿ",
      hero_subtitle: "AI ಯೊಂದಿಗೆ",
      hero_desc: "ನಿಮ್ಮ ಬೆಳೆಯ ಫೋಟೋ ಅಪ್ಲೋಡ್ ಮಾಡಿ ಮತ್ತು ತಕ್ಷಣ ರೋಗ ಪತ್ತೆ, ಚಿಕಿತ್ಸೆ ಸಲಹೆ ಪಡೆಯಿರಿ — ಸಂಪೂರ್ಣ ಉಚಿತ.",
      cta_scan: "ಈಗ ಬೆಳೆ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
      cta_doctor: "ಬೆಳೆ ವೈದ್ಯರನ್ನು ಕೇಳಿ",
      how_title: "FarmScan ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
      step1_title: "ಫೋಟೋ ಅಪ್ಲೋಡ್ ಮಾಡಿ",
      step1_desc: "ಪ್ರಭಾವಿತ ಎಲೆ ಅಥವಾ ಕಾಂಡದ ಸ್ಪಷ್ಟ ಫೋಟೋ ತೆಗೆಯಿರಿ",
      step2_title: "AI ವಿಶ್ಲೇಷಿಸುತ್ತದೆ",
      step2_desc: "ನಮ್ಮ AI ಮಾದರಿ 38 ರೋಗಗಳನ್ನು ತಕ್ಷಣ ಸ್ಕ್ಯಾನ್ ಮಾಡುತ್ತದೆ",
      step3_title: "ಫಲಿತಾಂಶ ಪಡೆಯಿರಿ",
      step3_desc: "ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ ರೋಗ ಮತ್ತು ಚಿಕಿತ್ಸೆ ತಿಳಿಯಿರಿ",
      features_title: "ರೈತರಿಗೆ ಬೇಕಾದ ಎಲ್ಲವೂ",
      feat1_title: "ರೋಗ ಪತ್ತೆ",
      feat1_desc: "ಫೋಟೋದಿಂದ ತಕ್ಷಣ AI ಪತ್ತೆ",
      feat2_title: "ಬೆಳೆ ವೈದ್ಯ",
      feat2_desc: "ಯಾವುದೇ ಪ್ರಶ್ನೆ ಕೇಳಿ, ತಜ್ಞ ಉತ್ತರ ಪಡೆಯಿರಿ",
      feat3_title: "ಹವಾಮಾನ ಎಚ್ಚರಿಕೆ",
      feat3_desc: "ಸ್ಥಳೀಯ ಹವಾಮಾನ ಆಧಾರಿತ ಕೃಷಿ ಸಲಹೆ",
      feat4_title: "38 ಬೆಳೆ ರೋಗಗಳು",
      feat4_desc: "54,000+ ನೈಜ ಚಿತ್ರಗಳ ಮೇಲೆ ತರಬೇತಿ ನೀಡಲಾಗಿದೆ",
      stats_scans: "ಸ್ಕ್ಯಾನ್ ಮಾಡಲಾಗಿದೆ",
      stats_diseases: "ರೋಗಗಳು ಪತ್ತೆಯಾದವು",
      stats_farmers: "ರೈತರಿಗೆ ಸಹಾಯ",
      stats_accuracy: "ನಿಖರತೆ"
    },
    scan: {
      title: "ಬೆಳೆ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
      subtitle: "ರೋಗ ತಕ್ಷಣ ಪತ್ತೆ ಮಾಡಲು ಫೋಟೋ ಅಪ್ಲೋಡ್ ಮಾಡಿ",
      upload_title: "ಇಲ್ಲಿ ಫೋಟೋ ಹಾಕಿ",
      upload_sub: "ಪ್ರಭಾವಿತ ಎಲೆ ಅಥವಾ ಕಾಂಡದ ಹತ್ತಿರದ ಫೋಟೋ ತೆಗೆಯಿರಿ",
      upload_btn: "ಫೋಟೋ ಆಯ್ಕೆ ಮಾಡಿ",
      crop_label: "ಬೆಳೆ ಪ್ರಕಾರ ಆಯ್ಕೆ ಮಾಡಿ",
      scan_btn: "ರೋಗ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
      scanning: "ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ...",
      result_title: "ಸ್ಕ್ಯಾನ್ ಫಲಿತಾಂಶ",
      confidence: "ವಿಶ್ವಾಸ",
      severity: "ತೀವ್ರತೆ",
      affected: "ಪ್ರಭಾವಿತ ಪ್ರದೇಶ",
      treatment: "ಶಿಫಾರಸು ಮಾಡಿದ ಚಿಕಿತ್ಸೆ",
      scan_again: "ಇನ್ನೊಂದು ಸ್ಕ್ಯಾನ್",
      healthy: "ನಿಮ್ಮ ಬೆಳೆ ಆರೋಗ್ಯಕರವಾಗಿ ಕಾಣುತ್ತದೆ!",
      no_disease: "ಯಾವುದೇ ರೋಗ ಪತ್ತೆಯಾಗಿಲ್ಲ"
    },
    doctor: {
      title: "ಬೆಳೆ ವೈದ್ಯ",
      subtitle: "ಯಾವುದೇ ಕೃಷಿ ಪ್ರಶ್ನೆ ಕೇಳಿ",
      placeholder: "ಉದಾ: ನನ್ನ ಟೊಮ್ಯಾಟೋ ಎಲೆಗಳು ಹಳದಿಯಾಗುತ್ತಿವೆ...",
      send: "ವೈದ್ಯರನ್ನು ಕೇಳಿ",
      thinking: "ಯೋಚಿಸುತ್ತಿದ್ದೇನೆ...",
      welcome: "ನಮಸ್ಕಾರ! ನಾನು ನಿಮ್ಮ AI ಬೆಳೆ ವೈದ್ಯ. ಕೃಷಿ, ರೋಗ, ಗೊಬ್ಬರ ಅಥವಾ ಮಣ್ಣಿನ ಬಗ್ಗೆ ಏನಾದರೂ ಕೇಳಿ."
    },
    weather: {
      title: "ಹವಾಮಾನ ಮತ್ತು ಕೃಷಿ ಎಚ್ಚರಿಕೆ",
      subtitle: "ಕೃಷಿ ಸಲಹೆಗಳೊಂದಿಗೆ ಸ್ಥಳೀಯ ಮುನ್ಸೂಚನೆ",
      detecting: "ನಿಮ್ಮ ಸ್ಥಳ ಪತ್ತೆ ಮಾಡಲಾಗುತ್ತಿದೆ...",
      humidity: "ತೇವಾಂಶ",
      wind: "ಗಾಳಿ",
      visibility: "ದೃಶ್ಯಮಾನತೆ",
      forecast: "5 ದಿನದ ಮುನ್ಸೂಚನೆ",
      tip_title: "ಇಂದಿನ ಕೃಷಿ ಸಲಹೆ",
      feel: "ಅನುಭವ"
    }
  }
};

export default translations;
